module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 3h35v35H3z\" fill-rule=\"evenodd\"></path></svg>"